// src/pages/OnboardingPage.js
import React, { useState, useEffect } from 'react';
import api from '../services/api';
import UniversalSearch from '../components/UniversalSearch';
import ParticipantCard from '../components/ParticipantCard';
import ParticipantDetailModal from '../components/ParticipantDetailModal';
import PipelineStats from '../components/PipelineStats';
import { Divider, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

const OnboardingPage = () => {
  const [searchResults, setSearchResults] = useState([]);
  const [onboardedList, setOnboardedList] = useState([]);
  const [selectedParticipantId, setSelectedParticipantId] = useState(null);

  // [-- THIS IS THE FIX --]
  const fetchOnboardedList = async () => {
    try {
      const response = await api.get('/api/workflow/onboarded-list');
      const onboarded = response.data.sort((a, b) => new Date(b.OnboardingTime) - new Date(a.OnboardingTime));
      setOnboardedList(onboarded);
    } catch (err) {
      console.error("Could not fetch onboarded list", err);
    }
  };

  useEffect(() => {
    fetchOnboardedList();
  }, []);

  const handleSearch = async (query) => {
    const response = await api.get(`/api/participants/search?query=${query}&status=all`);
    setSearchResults(response.data);
  };
  
  const openModal = (participantId) => setSelectedParticipantId(participantId);
  const closeModal = (updated) => {
    setSelectedParticipantId(null);
    if (updated) {
      setSearchResults([]);
      fetchOnboardedList();
    }
  };

  return (
    <>
      <PipelineStats />
      <UniversalSearch
        onSearch={handleSearch}
        title="Participant Onboarding"
        placeholder="Search for any participant to onboard..."
      />
      {searchResults.map(p => (
        <ParticipantCard
          key={p.ParticipantID}
          participant={p}
          onAction={openModal}
          pipeline="onboarding"
        />
      ))}
      
      <Divider sx={{ my: 4 }}><Typography>Recently Onboarded</Typography></Divider>

      <Paper>
        <TableContainer sx={{ maxHeight: 440 }}>
          <Table stickyHeader>
            <TableHead><TableRow><TableCell>Name</TableCell><TableCell>Email</TableCell><TableCell>Country</TableCell><TableCell>Onboarding Time</TableCell></TableRow></TableHead>
            <TableBody>
              {onboardedList.map((p) => (
                <TableRow hover key={p.ParticipantID}>
                  <TableCell>{p.FullName}</TableCell>
                  <TableCell>{p.EmailAddress}</TableCell>
                  <TableCell>{p.CountryName}</TableCell>
                  <TableCell>{p.OnboardingTime ? new Date(p.OnboardingTime).toLocaleString() : 'N/A'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      {selectedParticipantId && (
        <ParticipantDetailModal
          participantId={selectedParticipantId}
          open={!!selectedParticipantId}
          onClose={closeModal}
        />
      )}
    </>
  );
};

export default OnboardingPage;